import React from 'react';
import styled from 'styled-components';

const Page = styled.div`
  min-height: 100vh;
  background: #f8fafc;
  padding: 2.5rem 1rem 4rem;
`;

const Container = styled.div`
  max-width: 860px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 20px;
  padding: 2.25rem;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
  border: 1px solid #e5e7eb;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 1.5rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 700;
  color: #111827;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
`;

const Paragraph = styled.p`
  font-size: 0.95rem;
  color: #4b5563;
  line-height: 1.7;
  margin-bottom: 0.75rem;
`;

const List = styled.ul`
  padding-left: 1.25rem;
  color: #4b5563;
  line-height: 1.7;
  margin-bottom: 0.75rem;
`;

const ListItem = styled.li`
  margin-bottom: 0.35rem;
`;

const CookiePolicy = () => {
  return (
    <Page>
      <Container>
        <Title>Çerez Politikası</Title>
        <Paragraph>
          Bu Çerez Politikası, İşHazır (“Site”) tarafından kullanılan çerezler ve benzeri teknolojiler hakkında
          bilgi vermek amacıyla hazırlanmıştır.
        </Paragraph>

        <SectionTitle>1. Çerez Nedir?</SectionTitle>
        <Paragraph>
          Çerezler, bir web sitesini ziyaret ettiğinizde tarayıcınız aracılığıyla cihazınıza kaydedilen küçük metin
          dosyalarıdır. Çerezler, sitenin düzgün çalışmasını sağlamak, kullanıcı deneyimini geliştirmek ve analiz
          yapmak amacıyla kullanılır.
        </Paragraph>

        <SectionTitle>2. Kullanılan Çerez Türleri</SectionTitle>
        <Paragraph><strong>Zorunlu Çerezler</strong></Paragraph>
        <List>
          <ListItem>Bu çerezler, sitenin temel işlevlerini yerine getirebilmesi için gereklidir.</ListItem>
          <ListItem>Kimlik doğrulama, oturum yönetimi ve güvenlik gibi amaçlarla kullanılır.</ListItem>
          <ListItem>Bu çerezler için kullanıcı onayı aranmaz.</ListItem>
        </List>
        <Paragraph><strong>Analitik Çerezler</strong></Paragraph>
        <List>
          <ListItem>Sitenin nasıl kullanıldığını analiz etmek ve performansını iyileştirmek amacıyla kullanılır.</ListItem>
          <ListItem>Örneğin, ziyaret edilen sayfalar ve kullanım istatistikleri bu kapsamdadır.</ListItem>
          <ListItem>Analitik çerezler yalnızca kullanıcı onayı alınması halinde kullanılmaktadır.</ListItem>
        </List>
        <Paragraph><strong>Pazarlama Çerezleri</strong></Paragraph>
        <List>
          <ListItem>Kullanıcıya ilgi alanlarına yönelik reklamlar sunmak ve reklam performansını ölçmek amacıyla kullanılabilir.</ListItem>
          <ListItem>Pazarlama çerezleri yalnızca kullanıcı onayı alınması halinde kullanılmaktadır.</ListItem>
        </List>

        <SectionTitle>3. Üçüncü Taraf Çerezleri</SectionTitle>
        <Paragraph>
          Site üzerinde, üçüncü taraf hizmet sağlayıcılar (ör. Google Analytics, Google Ads, ödeme sağlayıcıları)
          tarafından yerleştirilen çerezler kullanılabilir. Bu çerezlerin yönetimi ilgili üçüncü tarafların kendi
          politikalarına tabidir.
        </Paragraph>

        <SectionTitle>4. Çerezlerin Yönetimi</SectionTitle>
        <Paragraph>
          Kullanıcılar, çerez tercihlerini tarayıcı ayarları üzerinden değiştirebilir veya çerezleri silebilir.
          Ayrıca, sitemizde sunulan çerez tercih aracı aracılığıyla analitik ve pazarlama çerezlerine ilişkin onaylar
          her zaman güncellenebilir.
        </Paragraph>

        <SectionTitle>5. Politika Güncellemeleri</SectionTitle>
        <Paragraph>
          Bu Çerez Politikası zaman zaman güncellenebilir. Güncellemeler Site üzerinden yayımlandığı tarihte yürürlüğe girer.
        </Paragraph>

        <SectionTitle>6. İletişim</SectionTitle>
        <Paragraph>
          Çerez Politikası hakkında sorularınız için bizimle iletişime geçebilirsiniz:
        </Paragraph>
        <Paragraph>📧 info@ishazir.com</Paragraph>
      </Container>
    </Page>
  );
};

export default CookiePolicy;
